/* Wrenlo theme scripts — no dependencies */
(function () {
  'use strict';

  var T = window.theme || {};

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toLocaleString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100).toString());
  }

  /* ---------- toast ---------- */
  var toastEl = document.getElementById('Toast');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.querySelector('span').textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2400);
  }

  /* ---------- cart count ---------- */
  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n < 1;
    });
  }
  function refreshCart() {
    fetch(T.cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); })
      .catch(function () {});
  }

  /* ============================================================
     SLIDESHOW
     ============================================================ */
  function initSlideshow(root) {
    var track = root.querySelector('[data-hs-track]');
    var slides = root.querySelectorAll('[data-hs-slide]');
    var dots = root.querySelectorAll('[data-hs-dot]');
    if (!track || slides.length < 1) return;

    var i = 0;
    var timer = null;
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      slides.forEach(function (s, idx) { s.setAttribute('aria-hidden', idx !== i); });
      dots.forEach(function (d, idx) {
        d.classList.remove('on');
        if (idx === i) { void d.offsetWidth; d.classList.add('on'); }
        d.setAttribute('aria-selected', idx === i);
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      stop();
      if (reduce || slides.length < 2) return;
      timer = setInterval(function () { go(i + 1); }, speed);
    }

    root.querySelectorAll('[data-hs-prev]').forEach(function (b) {
      b.addEventListener('click', function () { go(i - 1); play(); });
    });
    root.querySelectorAll('[data-hs-next]').forEach(function (b) {
      b.addEventListener('click', function () { go(i + 1); play(); });
    });
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { go(idx); play(); });
    });

    root.addEventListener('mouseenter', function () {
      stop();
      var d = root.querySelector('[data-hs-dot].on');
      if (d) d.classList.add('paused');
    });
    root.addEventListener('mouseleave', function () {
      var d = root.querySelector('[data-hs-dot].on');
      if (d) d.classList.remove('paused');
      play();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(i + 1); play(); }
      if (e.key === 'ArrowLeft') { go(i - 1); play(); }
    });

    // touch swipe
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
      play();
    });

    root.style.setProperty('--hs-speed', speed + 'ms');
    go(0);
    play();
  }

  /* ============================================================
     PRODUCT FORM: gallery, variants, bundles, qty, ajax add
     ============================================================ */
  function initProduct(root) {
    var form = root.querySelector('form[action*="/cart/add"]');
    var variantsEl = root.querySelector('[data-variants]');
    var variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-variant-id]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var priceOff = root.querySelector('[data-price-off]');
    var addBtn = root.querySelector('[data-add-btn]');
    var addLabel = root.querySelector('[data-add-label]');
    var sbPrice = document.querySelector('[data-sb-price]');
    var selected = {};

    root.querySelectorAll('[data-opt-value].on').forEach(function (b) {
      selected[b.getAttribute('data-opt-index')] = b.getAttribute('data-opt-value');
    });

    // Every option index this product actually has.
    var optKeys = [];
    root.querySelectorAll('[data-opt-index]').forEach(function (b) {
      var k = b.getAttribute('data-opt-index');
      if (optKeys.indexOf(k) === -1) optKeys.push(k);
    });

    // Exact match on EVERY option. No fallback: a combination that does not
    // exist must not quietly resolve to some other variant, or the customer
    // buys a thing they did not pick.
    function variantFor(sel) {
      return variants.find(function (v) {
        return optKeys.every(function (k) { return v.options[k] === sel[k]; });
      });
    }

    function currentVariant() {
      return variantFor(selected);
    }

    // Pick a value, then repair the rest of the selection if that value does
    // not co-exist with it. Prefers keeping what the customer already chose,
    // then an in-stock variant, then any variant at all.
    function snapTo(idx, val) {
      var want = Object.assign({}, selected);
      want[idx] = val;
      if (variantFor(want)) { selected = want; return; }

      var pool = variants.filter(function (v) { return v.options[idx] === val; });
      if (!pool.length) return;                       // value belongs to no variant

      var best = null, bestScore = -1;
      pool.forEach(function (v) {
        var score = 0;
        optKeys.forEach(function (k) {
          if (k !== idx && v.options[k] === selected[k]) score += 2;   // keep their choices
        });
        if (v.available) score += 1;                                   // prefer buyable
        if (score > bestScore) { bestScore = score; best = v; }
      });
      if (!best) return;

      var next = {};
      optKeys.forEach(function (k) { next[k] = best.options[k]; });
      selected = next;
    }

    function unitPrice() {
      var v = currentVariant();
      return v ? v.price : 0;
    }

    function activeBundle() {
      var b = root.querySelector('[data-bundle].on');
      return {
        qty: b ? parseInt(b.getAttribute('data-bundle-qty'), 10) : (qtyInput ? parseInt(qtyInput.value, 10) : 1),
        pct: b ? parseFloat(b.getAttribute('data-bundle-pct')) : 0
      };
    }

    function update() {
      var v = currentVariant();
      var bun = activeBundle();
      if (!v) {
        // Should be unreachable once snapTo runs, but never let the form post
        // an id that does not match what is on screen.
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = v.id;
      if (qtyInput) qtyInput.value = bun.qty;

      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = money(v.compare_at_price);
          priceWas.hidden = false;
          if (priceOff) {
            priceOff.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
            priceOff.hidden = false;
          }
        } else {
          priceWas.hidden = true;
          if (priceOff) priceOff.hidden = true;
        }
      }

      // bundle totals recalc against the selected variant
      root.querySelectorAll('[data-bundle]').forEach(function (b) {
        var q = parseInt(b.getAttribute('data-bundle-qty'), 10);
        var pct = parseFloat(b.getAttribute('data-bundle-pct')) || 0;
        var total = Math.round(v.price * q * (1 - pct / 100));
        var t = b.querySelector('[data-bundle-total]');
        var e = b.querySelector('[data-bundle-each]');
        var s = b.querySelector('[data-bundle-save]');
        if (t) t.textContent = money(total);
        if (e) e.textContent = money(Math.round(total / q)) + ' each';
        if (s && pct > 0) s.textContent = 'Save ' + money(v.price * q - total);
      });

      var lineTotal = Math.round(v.price * bun.qty * (1 - bun.pct / 100));
      if (addLabel) addLabel.textContent = v.available ? 'Add to cart · ' + money(lineTotal) : 'Sold out';
      if (addBtn) addBtn.disabled = !v.available;
      if (sbPrice) sbPrice.textContent = money(lineTotal);

      // Fade every option value that cannot be had alongside the current
      // selection -- both "sold out" AND "that pairing does not exist".
      // The old code only faded sold-out ones, so an impossible pairing like
      // White + 10pc looked perfectly buyable.
      root.querySelectorAll('[data-opt-value]').forEach(function (b) {
        var idx = b.getAttribute('data-opt-index');
        var val = b.getAttribute('data-opt-value');
        var probe = Object.assign({}, selected);
        probe[idx] = val;
        var match = variantFor(probe);
        var ok = !!match && match.available;
        b.classList.toggle('soldout', !ok);

        // Faded, but still clickable: clicking snaps the other options to a
        // combination that does exist. So do NOT mark it aria-disabled --
        // it genuinely does something. Say why instead.
        b.removeAttribute('aria-disabled');
        if (ok) {
          b.removeAttribute('title');
        } else if (match) {
          b.setAttribute('title', 'Sold out');
        } else {
          var reachable = variants.some(function (vv) { return vv.options[idx] === val; });
          b.setAttribute('title', reachable
            ? 'Not sold with your current choice \u2014 tap to switch'
            : 'Unavailable');
          if (!reachable) b.disabled = true;
        }
      });

      // Reflect the (possibly repaired) selection back onto the buttons.
      root.querySelectorAll('[data-opt-value]').forEach(function (b) {
        var idx = b.getAttribute('data-opt-index');
        var isOn = selected[idx] === b.getAttribute('data-opt-value');
        b.classList.toggle('on', isOn);
        if (b.getAttribute('role') === 'radio') b.setAttribute('aria-checked', isOn ? 'true' : 'false');
      });

      // move the gallery to this variant's own photo
      if (v && v.image) showMediaById(v.image);

      // reflect the chosen value next to each option label
      root.querySelectorAll('[data-opt-chosen]').forEach(function (el) {
        var k = el.getAttribute('data-opt-chosen');
        if (selected[k]) el.textContent = selected[k];
      });

      // sticky bar mirrors the selection
      var sbVar = document.querySelector('[data-sb-variant]');
      if (sbVar && v && v.title) sbVar.textContent = v.title;
      var sbImg = document.querySelector('[data-sb-img]');
      if (sbImg && v && v.image) {
        var mm = root.querySelector('[data-gimg="' + v.image + '"]');
        if (mm) sbImg.src = mm.currentSrc || mm.src;
      }

      if (history.replaceState && v.id) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-opt-value]').forEach(function (b) {
      b.addEventListener('click', function () {
        snapTo(b.getAttribute('data-opt-index'), b.getAttribute('data-opt-value'));
        update();   // update() repaints which buttons are on and which are faded
      });
    });

    root.querySelectorAll('[data-bundle]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-bundle]').forEach(function (o) { o.classList.remove('on'); });
        b.classList.add('on');
        update();
      });
    });

    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var n = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, n + parseInt(b.getAttribute('data-qty-step'), 10));
        root.querySelectorAll('[data-bundle]').forEach(function (o) { o.classList.remove('on'); });
        update();
      });
    });

    // ---- gallery: index-based so thumbs, arrows, swipe and variant changes all agree
    var gImgs  = Array.prototype.slice.call(root.querySelectorAll('[data-gimg]'));
    var gThumb = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var gCount = root.querySelector('[data-gcount]');
    var gIndex = 0;

    function showMediaIndex(i) {
      if (!gImgs.length) return;
      gIndex = ((i % gImgs.length) + gImgs.length) % gImgs.length;
      gImgs.forEach(function (img, n) { img.classList.toggle('on', n === gIndex); });
      gThumb.forEach(function (t, n) { t.classList.toggle('on', n === gIndex); });
      if (gCount) gCount.textContent = (gIndex + 1) + ' / ' + gImgs.length;
      var active = gThumb[gIndex];
      if (active && active.scrollIntoView) {
        try { active.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {}
      }
    }
    function showMediaById(id) {
      for (var n = 0; n < gImgs.length; n++) {
        if (gImgs[n].getAttribute('data-gimg') === String(id)) { showMediaIndex(n); return true; }
      }
      return false;
    }

    gThumb.forEach(function (b, n) {
      b.addEventListener('click', function () { showMediaIndex(n); });
    });
    var gPrev = root.querySelector('[data-gprev]');
    var gNext = root.querySelector('[data-gnext]');
    if (gPrev) gPrev.addEventListener('click', function () { showMediaIndex(gIndex - 1); });
    if (gNext) gNext.addEventListener('click', function () { showMediaIndex(gIndex + 1); });

    // swipe on touch devices
    var gWrap = root.querySelector('[data-gallery]');
    if (gWrap && gImgs.length > 1) {
      var tx = 0, ty = 0;
      gWrap.addEventListener('touchstart', function (e) {
        tx = e.changedTouches[0].clientX; ty = e.changedTouches[0].clientY;
      }, { passive: true });
      gWrap.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - tx;
        var dy = e.changedTouches[0].clientY - ty;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) showMediaIndex(gIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    // sticky bar mirrors the main add button
    var sbBtn = document.querySelector('[data-sb-add]');
    if (sbBtn && form) sbBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); });

    // ajax add to cart
    if (form && T.cartAjax !== false) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        fetch(T.cartAddUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: parseInt(qtyInput.value, 10) || 1 })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.d.description || 'error');
            toast(T.strings.added || 'Added to cart');
            refreshCart();
          })
          .catch(function () { toast(T.strings.error || 'Something went wrong.'); })
          .then(function () { if (addBtn) addBtn.disabled = false; });
      });
    }

    update();
  }

  /* ============================================================
     STICKY BAR VISIBILITY
     ============================================================ */
  function initSticky() {
    var bar = document.querySelector('[data-sticky-buy]');
    if (!bar) return;
    bar.classList.add('show');
    document.body.classList.add('has-sticky');
  }

  /* ============================================================
     MISC
     ============================================================ */
  function initSort() {
    document.querySelectorAll('[data-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }
  function initFilters() {
    document.querySelectorAll('[data-filter-form]').forEach(function (f) {
      f.addEventListener('change', function () { f.submit(); });
    });
  }
  function initCartQty() {
    document.querySelectorAll('[data-cart-remove]').forEach(function (a) {
      a.addEventListener('click', function () { /* let the link navigate */ });
    });
  }

  /* ============================================================
     SIGNUP POPUP
     ============================================================ */
  function initSignup(root) {
    var m = root || document.querySelector('[data-signup]');
    if (!m) return;
    var key = 'sawSignup';
    var seen = false;
    try { seen = localStorage.getItem(key) === '1'; } catch (e) {}
    function close() {
      m.classList.remove('show');
      try { localStorage.setItem(key, '1'); } catch (e) {}
    }
    var delay = parseInt(m.getAttribute('data-delay'), 10) || 4000;
    if (!seen) setTimeout(function () { m.classList.add('show'); }, delay);
    m.querySelectorAll('[data-signup-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var f = m.querySelector('form');
    if (f) f.addEventListener('submit', function () { try { localStorage.setItem(key, '1'); } catch (e) {} });
  }

  /* ============================================================
     FLOATING SHIPPING DOT
     ============================================================ */
  function initShipDot(root) {
    var d = root || document.querySelector('[data-shipdot]');
    if (!d) return;
    setTimeout(function () { d.classList.add('open'); }, 1400);
    setTimeout(function () { d.classList.remove('open'); }, 6200);
    d.addEventListener('click', function () { d.classList.toggle('open'); });
  }


  /* ============================================================
     PREDICTIVE SEARCH
     ============================================================ */
  function esc(t){ return String(t==null?'':t).replace(/[&<>"']/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  function highlight(text, q){
    var t = esc(text);
    if (!q) return t;
    var terms = q.trim().split(/\s+/).filter(Boolean)
      .map(function(w){ return w.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'); });
    if (!terms.length) return t;
    try { return t.replace(new RegExp('(' + terms.join('|') + ')','ig'), '<mark>$1</mark>'); }
    catch(e){ return t; }
  }

  var RECENT_KEY = 'theme:recent-searches';
  function recentGet(){
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch(e){ return []; }
  }
  function recentAdd(q){
    q = (q||'').trim(); if (q.length < 2) return;
    try {
      var list = recentGet().filter(function(x){ return x.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0,6)));
    } catch(e){}
  }

  function initSearch(root){
    if (!root || root.dataset.psInit) return;
    root.dataset.psInit = '1';

    var input = root.querySelector('[data-psearch-input]');
    var pop   = root.querySelector('[data-psearch-pop]');
    var body  = root.querySelector('[data-psearch-body]');
    var foot  = root.querySelector('[data-psearch-foot]');
    var all   = root.querySelector('[data-psearch-all]');
    var clear = root.querySelector('[data-psearch-clear]');
    var form  = root.querySelector('form');
    if (!input || !pop || !body) return;

    var S        = T.strings || {};
    /* routes.predictive_search_url is /search/suggest which returns HTML.
       The JSON endpoint is the same path with .json — without it res.json() throws
       and the dropdown silently shows nothing. */
    var base     = (root.getAttribute('data-psearch-url') || '/search/suggest').replace(/\.json$/,'') + '.json';
    var searchUrl= root.getAttribute('data-search-url') || '/search';
    var popular  = (root.getAttribute('data-popular') || '').split(',')
                     .map(function(x){ return x.trim(); }).filter(Boolean);

    var timer = null, controller = null, idx = -1, lastQ = '';

    function open(){ pop.hidden = false; input.setAttribute('aria-expanded','true'); }
    function close(){ pop.hidden = true; input.setAttribute('aria-expanded','false'); idx = -1; }
    function items(){ return Array.prototype.slice.call(pop.querySelectorAll('.ps-item')); }

    function move(step){
      var list = items(); if (!list.length) return;
      list.forEach(function(el){ el.classList.remove('on'); });
      idx += step;
      if (idx < 0) idx = list.length - 1;
      if (idx >= list.length) idx = 0;
      var el = list[idx];
      el.classList.add('on');
      if (el.scrollIntoView) el.scrollIntoView({ block:'nearest' });
    }

    function chipRow(label, list){
      if (!list.length) return '';
      return '<div class="ps-group"><div class="ps-label">' + esc(label) + '</div><div class="ps-chips">' +
        list.map(function(q){
          return '<button type="button" class="ps-chip" data-ps-term="' + esc(q) + '">' + esc(q) + '</button>';
        }).join('') + '</div></div>';
    }

    function showIdle(){
      var html = '';
      var rec = recentGet();
      if (rec.length)     html += chipRow(S.recent  || 'Recent searches', rec);
      if (popular.length) html += chipRow(S.popular || 'Popular right now', popular);
      if (!html) { close(); return; }
      body.innerHTML = html;
      foot.hidden = true;
      idx = -1;
      open();
    }

    function row(opts){
      var thumb = opts.image
        ? '<span class="ps-ic"><img src="' + esc(opts.image) + '" alt="" loading="lazy"></span>'
        : '<span class="ps-ic">' + (opts.icon || '') + '</span>';
      return '<a class="ps-item' + (opts.image ? ' thumb' : '') + '" href="' + esc(opts.url) + '">' +
        thumb +
        '<span class="ps-txt"><span class="ps-t">' + opts.title + '</span>' +
        (opts.sub ? '<span class="ps-s">' + esc(opts.sub) + '</span>' : '') +
        '</span>' +
        (opts.price ? '<span class="ps-p">' + esc(opts.price) + '</span>' : '') +
        '</a>';
    }

    var ICON_GRID = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>';
    var ICON_PAGE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4"/><path d="M9 12h6M9 16h4"/></svg>';
    var ICON_SEARCH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20.5 20.5 16.7 16.7"/></svg>';

    function render(data, q){
      var r = (data && data.resources && data.resources.results) || {};
      var html = '';

      var queries = (r.queries || []).slice(0,4);
      if (queries.length){
        html += '<div class="ps-group"><div class="ps-label">' + esc(S.suggestions || 'Suggestions') + '</div>' +
          queries.map(function(x){
            return row({ url:x.url, title: highlight(x.text, q), icon: ICON_SEARCH });
          }).join('') + '</div>';
      }

      var cols = (r.collections || []).slice(0,4);
      if (cols.length){
        html += '<div class="ps-group"><div class="ps-label">' + esc(S.categories || 'Categories') + '</div>' +
          cols.map(function(c){
            return row({ url:c.url, title: highlight(c.title, q), icon: ICON_GRID });
          }).join('') + '</div>';
      }

      var prods = (r.products || []).slice(0,6);
      if (prods.length){
        html += '<div class="ps-group"><div class="ps-label">' + esc(S.products || 'Products') + '</div>' +
          prods.map(function(pr){
            var img = pr.featured_image && pr.featured_image.url ? pr.featured_image.url : (pr.image || '');
            var price = pr.price != null ? money(parseInt(pr.price,10)) : '';
            return row({
              url: pr.url, title: highlight(pr.title, q),
              sub: pr.vendor || pr.product_type || '',
              image: img, price: price
            });
          }).join('') + '</div>';
      }

      var pages = (r.pages || []).slice(0,3);
      if (pages.length){
        html += '<div class="ps-group"><div class="ps-label">' + esc(S.pages || 'Pages') + '</div>' +
          pages.map(function(pg){
            return row({ url:pg.url, title: highlight(pg.title, q), icon: ICON_PAGE });
          }).join('') + '</div>';
      }

      var arts = (r.articles || []).slice(0,2);
      if (arts.length){
        html += '<div class="ps-group"><div class="ps-label">Guides</div>' +
          arts.map(function(a){
            return row({ url:a.url, title: highlight(a.title, q), icon: ICON_PAGE });
          }).join('') + '</div>';
      }

      if (!html){
        body.innerHTML = '<div class="ps-none">' + esc(S.noMatches || 'No matches yet') + '</div>';
        foot.hidden = true;
      } else {
        body.innerHTML = html;
        if (all){
          all.href = searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
          all.textContent = (S.seeAllFor || 'See all results for') + ' “' + q + '”';
        }
        foot.hidden = false;
      }
      idx = -1;
      open();
    }

    function fetchNow(q){
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;
      var url = base + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,article,query' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function(res){ return res.json(); })
        .then(function(data){ if (q === lastQ) render(data, q); })
        .catch(function(){});
    }

    input.addEventListener('input', function(){
      var q = input.value.trim();
      lastQ = q;
      if (clear) clear.hidden = q.length === 0;
      clearTimeout(timer);
      if (q.length < 1){ showIdle(); return; }
      timer = setTimeout(function(){ fetchNow(q); }, 170);
    });

    input.addEventListener('focus', function(){
      if (input.value.trim().length < 1) showIdle();
      else if (body.innerHTML) open();
    });

    input.addEventListener('keydown', function(e){
      if (e.key === 'ArrowDown'){ e.preventDefault(); if (pop.hidden) showIdle(); move(1); }
      else if (e.key === 'ArrowUp'){ e.preventDefault(); move(-1); }
      else if (e.key === 'Enter'){
        var list = items();
        if (idx > -1 && list[idx]){
          e.preventDefault();
          if (list[idx].tagName === 'A') { recentAdd(input.value); window.location.href = list[idx].href; }
          else list[idx].click();
        } else { recentAdd(input.value); }
      }
      else if (e.key === 'Escape'){ close(); input.blur(); }
    });

    pop.addEventListener('click', function(e){
      var chip = e.target.closest('[data-ps-term]');
      if (chip){
        input.value = chip.getAttribute('data-ps-term');
        lastQ = input.value;
        if (clear) clear.hidden = false;
        fetchNow(input.value);
        input.focus();
        return;
      }
      var link = e.target.closest('.ps-item');
      if (link) recentAdd(input.value);
    });

    if (clear) clear.addEventListener('click', function(){
      input.value = ''; clear.hidden = true; lastQ = ''; showIdle(); input.focus();
    });

    if (form) form.addEventListener('submit', function(){ recentAdd(input.value); });

    document.addEventListener('click', function(e){
      if (!root.contains(e.target)) close();
    });
  }

  /* ============================================================
     MEGA MENU (hover + keyboard)
     ============================================================ */
  function initMega(){
    var bar = document.querySelector('[data-megabar]');
    if (!bar || bar.dataset.megaInit) return;
    bar.dataset.megaInit = '1';

    var cats = Array.prototype.slice.call(bar.querySelectorAll('[data-cat]'));
    var openTimer = null, closeTimer = null;

    function closeAll(){
      cats.forEach(function(c){
        c.classList.remove('open');
        var m = c.querySelector('[data-mega]'); if (m) m.hidden = true;
        var t = c.querySelector('[data-cat-top]'); if (t) t.setAttribute('aria-expanded','false');
      });
    }
    /* The nav strip scrolls horizontally when there are many departments, and an
       overflow container clips an absolutely-positioned child. So the panel is
       position:fixed and we place it under the bar ourselves. */
    function place(m){
      var r = bar.getBoundingClientRect();
      m.style.top = Math.round(r.bottom) + 'px';
    }
    function openCat(c){
      closeAll();
      c.classList.add('open');
      var m = c.querySelector('[data-mega]');
      if (m) { place(m); m.hidden = false; }
      var t = c.querySelector('[data-cat-top]'); if (t) t.setAttribute('aria-expanded','true');
    }

    cats.forEach(function(c){
      c.addEventListener('mouseenter', function(){
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function(){ openCat(c); }, 90);
      });
      c.addEventListener('mouseleave', function(){
        clearTimeout(openTimer);
        closeTimer = setTimeout(closeAll, 180);
      });
      var top = c.querySelector('[data-cat-top]');
      if (top){
        top.addEventListener('focus', function(){ openCat(c); });
        top.addEventListener('keydown', function(e){
          if (e.key === 'ArrowDown'){
            e.preventDefault(); openCat(c);
            var first = c.querySelector('.mega a'); if (first) first.focus();
          }
        });
      }
      c.addEventListener('focusout', function(e){
        if (!c.contains(e.relatedTarget)) {
          c.classList.remove('open');
          var m = c.querySelector('[data-mega]'); if (m) m.hidden = true;
          var t = c.querySelector('[data-cat-top]'); if (t) t.setAttribute('aria-expanded','false');
        }
      });
    });

    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeAll(); });
    window.addEventListener('scroll', function(){
      var open = bar.querySelector('.cat.open [data-mega]');
      if (open) place(open);
    }, { passive: true });
    window.addEventListener('resize', closeAll);
  }

  /* ============================================================
     MOBILE DRAWER
     ============================================================ */
  function initDrawer(){
    var drawer = document.querySelector('[data-drawer]');
    if (!drawer || drawer.dataset.drInit) return;
    drawer.dataset.drInit = '1';

    var title = drawer.querySelector('[data-drawer-title]');
    var back  = drawer.querySelector('[data-drawer-back]');
    var root  = drawer.querySelector('[data-dlevel="0"]');
    var rootTitle = title ? title.textContent : 'Menu';
    var stack = [];

    function showPanel(el, label){
      drawer.querySelectorAll('.dlist').forEach(function(l){ l.hidden = true; });
      el.hidden = false;
      if (title) title.textContent = label;
      if (back) back.hidden = stack.length === 0;
      var sc = drawer.querySelector('.drawer-scroll'); if (sc) sc.scrollTop = 0;
    }
    function openDrawer(){
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      document.querySelectorAll('[data-drawer-open]').forEach(function(b){ b.setAttribute('aria-expanded','true'); });
      var f = drawer.querySelector('.drawer-x'); if (f) f.focus();
    }
    function closeDrawer(){
      drawer.hidden = true;
      document.body.style.overflow = '';
      document.querySelectorAll('[data-drawer-open]').forEach(function(b){ b.setAttribute('aria-expanded','false'); });
      stack = [];
      if (root) showPanel(root, rootTitle);
    }

    document.querySelectorAll('[data-drawer-open]').forEach(function(b){
      b.addEventListener('click', openDrawer);
    });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function(b){
      b.addEventListener('click', closeDrawer);
    });

    drawer.addEventListener('click', function(e){
      var opener = e.target.closest('[data-dopen]');
      if (opener){
        var key = opener.getAttribute('data-dopen');
        var panel = drawer.querySelector('[data-dpanel="' + key + '"]');
        if (panel){
          stack.push({ el: drawer.querySelector('.dlist:not([hidden])'), label: title ? title.textContent : '' });
          showPanel(panel, panel.getAttribute('data-dtitle') || '');
        }
      }
    });

    if (back) back.addEventListener('click', function(){
      var prev = stack.pop();
      if (prev && prev.el) showPanel(prev.el, prev.label);
      else if (root) showPanel(root, rootTitle);
    });

    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  }

  /* ============================================================
     COUNTRY / REGION SELECTOR
     ============================================================ */
  function initCountry(){
    document.querySelectorAll('[data-country]').forEach(function(form){
      if (form.dataset.cInit) return;
      form.dataset.cInit = '1';
      var btn = form.querySelector('[data-country-toggle]');
      var pop = form.querySelector('[data-country-pop]');
      if (!btn || !pop) return;
      btn.addEventListener('click', function(){
        var open = pop.hidden;
        pop.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open){ var cur = pop.querySelector('button.on') || pop.querySelector('button'); if (cur) cur.focus(); }
      });
      document.addEventListener('click', function(e){
        if (!form.contains(e.target)){ pop.hidden = true; btn.setAttribute('aria-expanded','false'); }
      });
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && !pop.hidden){ pop.hidden = true; btn.setAttribute('aria-expanded','false'); btn.focus(); }
      });
    });
  }

  /* ============================================================
     FAVOURITES / SAVED
     ============================================================ */
  var FAV_KEY = 'theme:saved-items';
  function favAll(){
    try { var v = JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch(e){ return []; }
  }
  function favSave(list){
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list.slice(0,120))); } catch(e){}
    favPaint();
  }
  function favHas(handle){
    return favAll().some(function(x){ return x.handle === handle; });
  }
  function favPaint(){
    var list = favAll();
    document.querySelectorAll('[data-fav-count]').forEach(function(el){
      el.textContent = list.length;
      el.hidden = list.length < 1;
    });
    document.querySelectorAll('[data-fav]').forEach(function(b){
      b.setAttribute('aria-pressed', favHas(b.getAttribute('data-handle')) ? 'true' : 'false');
    });
  }
  function favToggle(btn){
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var list = favAll();
    var i = -1;
    list.forEach(function(x, n){ if (x.handle === handle) i = n; });
    var S = T.strings || {};
    if (i > -1){ list.splice(i,1); toast(S.unsaved || 'Removed'); }
    else {
      list.unshift({
        handle: handle,
        title: btn.getAttribute('data-title') || '',
        url: btn.getAttribute('data-url') || '',
        price: btn.getAttribute('data-price') || '',
        image: btn.getAttribute('data-image') || ''
      });
      toast(S.saved || 'Saved');
    }
    favSave(list);
  }
  function initFav(){
    if (document.body.dataset.favInit) return;
    document.body.dataset.favInit = '1';
    document.addEventListener('click', function(e){
      var b = e.target.closest('[data-fav]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      favToggle(b);
    });
    favPaint();
  }
  function initSavedPage(){
    var grid = document.querySelector('[data-saved-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-saved-empty]');
    var bar   = document.querySelector('[data-saved-bar]');
    var count = document.querySelector('[data-saved-count]');
    var clear = document.querySelector('[data-saved-clear]');
    var S = T.strings || {};

    function paint(){
      var list = favAll();
      if (!list.length){
        grid.hidden = true; if (bar) bar.hidden = true; if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;
      grid.hidden = false; if (bar) bar.hidden = false;
      if (count) count.textContent = list.length + ' ' + (S.itemsSaved || 'items saved');
      grid.innerHTML = list.map(function(x){
        var img = x.image
          ? '<img src="' + esc(x.image) + '" alt="" loading="lazy">'
          : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.1"><path d="m21 8-9-5-9 5 9 5 9-5z"/><path d="M3 8v8l9 5 9-5V8"/></svg>';
        return '<div class="pcard">' +
          '<span class="pthumb">' + img +
            '<button type="button" class="pfav" data-fav aria-pressed="true" data-handle="' + esc(x.handle) + '"' +
            ' data-title="' + esc(x.title) + '" data-url="' + esc(x.url) + '" data-price="' + esc(x.price) + '"' +
            ' data-image="' + esc(x.image) + '" aria-label="Remove">' +
            '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.9"><path d="M20.8 5.1a5.2 5.2 0 0 0-7.4 0L12 6.5l-1.4-1.4a5.2 5.2 0 1 0-7.4 7.4l8.8 8.8 8.8-8.8a5.2 5.2 0 0 0 0-7.4z"/></svg>' +
            '</button>' +
          '</span>' +
          '<span class="pbody">' +
            '<a class="ptitle pstretch" href="' + esc(x.url) + '">' + esc(x.title) + '</a>' +
            '<span class="pprice"><span class="now tnum">' + esc(x.price) + '</span></span>' +
          '</span>' +
        '</div>';
      }).join('');
    }

    grid.addEventListener('click', function(e){
      if (e.target.closest('[data-fav]')) setTimeout(paint, 0);
    });
    if (clear) clear.addEventListener('click', function(){ favSave([]); paint(); });
    paint();
  }


  /* ============================================================
     CATEGORY TILES -> SUBCATEGORY PANEL
     ============================================================ */
  function initCatx(root){
    root = root || document.querySelector('[data-catx]');
    if (!root || root.dataset.cxInit) return;
    root.dataset.cxInit = '1';

    var tiles  = Array.prototype.slice.call(root.querySelectorAll('[data-catx-tile]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-catx-panel]'));
    if (!tiles.length || !panels.length) return;

    function panelFor(key){
      for (var i = 0; i < panels.length; i++){
        if (panels[i].getAttribute('data-catx-panel') === key) return panels[i];
      }
      return null;
    }
    function closeAll(){
      panels.forEach(function(p){ p.hidden = true; });
      tiles.forEach(function(t){ t.setAttribute('aria-expanded','false'); });
    }
    function open(tile){
      var key = tile.getAttribute('data-catx-tile');
      var p = panelFor(key);
      if (!p) return false;
      var wasOpen = !p.hidden;
      closeAll();
      if (wasOpen) return true;
      p.hidden = false;
      tile.setAttribute('aria-expanded','true');
      return true;
    }

    tiles.forEach(function(t){
      t.addEventListener('click', function(e){
        /* let modified clicks behave like a normal link so the department page
           can still be opened in a new tab */
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        if (open(t)) e.preventDefault();
      });
    });

    root.querySelectorAll('[data-catx-close]').forEach(function(b){
      b.addEventListener('click', closeAll);
    });

    document.addEventListener('keydown', function(e){
      if (e.key !== 'Escape') return;
      var openTile = root.querySelector('[data-catx-tile][aria-expanded="true"]');
      if (openTile){ closeAll(); openTile.focus(); }
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    document.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    document.querySelectorAll('[data-product-root]').forEach(initProduct);
    initSticky();
    initSort();
    initFilters();
    initCartQty();
    initSignup();
    initShipDot();
    document.querySelectorAll('[data-psearch]').forEach(initSearch);
    document.querySelectorAll('[data-catx]').forEach(initCatx);
    initMega();
    initDrawer();
    initCountry();
    initFav();
    initSavedPage();
    refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Shopify theme editor re-renders sections without a page reload
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    e.target.querySelectorAll('[data-product-root]').forEach(initProduct);
    e.target.querySelectorAll('[data-signup]').forEach(initSignup);
    e.target.querySelectorAll('[data-shipdot]').forEach(initShipDot);
    e.target.querySelectorAll('[data-psearch]').forEach(initSearch);
    e.target.querySelectorAll('[data-catx]').forEach(initCatx);
    initMega();
    initDrawer();
    initCountry();
    favPaint();
    initSavedPage();
    initSticky();
  });
})();

/* ---------------------------------------------------------------
   FAQ accordion.
   Shopify's page editor strips <details>/<summary>/<style>, so the
   page content is stored as plain paragraphs:
       <p><strong>Question?</strong><br>Answer...</p>
   This turns each of those into a real <details> row at render time,
   which means the FAQ can still be edited normally in Shopify admin.
   Any element that follows a question (a table, an extra paragraph)
   is folded into that question's answer until the next question or
   the next heading.
---------------------------------------------------------------- */
(function () {
  function isHeading(el) {
    return /^H[1-6]$/.test(el.tagName);
  }

  // A question is a <p> that opens with <strong> and is followed by a <br>.
  function questionStrong(el) {
    if (el.tagName !== 'P') return null;
    var first = el.firstChild;
    while (first && first.nodeType === 3 && !first.nodeValue.trim()) first = first.nextSibling;
    if (!first || first.nodeType !== 1 || first.tagName !== 'STRONG') return null;
    var after = first.nextSibling;
    while (after && after.nodeType === 3 && !after.nodeValue.trim()) after = after.nextSibling;
    if (!after || after.nodeType !== 1 || after.tagName !== 'BR') return null;
    if (!first.textContent.trim()) return null;
    return first;
  }

  function slug(t) {
    return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
  }

  function build(root) {
    var kids = Array.prototype.slice.call(root.children);
    var groups = [];
    var current = null;

    kids.forEach(function (el) {
      if (isHeading(el)) { current = null; return; }
      var st = questionStrong(el);
      if (st) {
        current = { p: el, strong: st, extra: [] };
        groups.push(current);
      } else if (current) {
        current.extra.push(el);
      }
    });

    if (!groups.length) return;
    var used = {};

    groups.forEach(function (g) {
      var d = document.createElement('details');
      var sm = document.createElement('summary');
      var label = g.strong.textContent.trim();
      sm.textContent = label;
      var id = slug(label);
      if (id) {
        if (used[id]) { id = id + '-' + (++used[id]); } else { used[id] = 1; }
        d.id = id;
      }
      d.appendChild(sm);

      var body = document.createElement('div');
      body.className = 'acc-a';

      var p = g.p;
      p.removeChild(g.strong);
      // drop the leading <br> and any whitespace before it
      var node = p.firstChild;
      while (node) {
        var next = node.nextSibling;
        if (node.nodeType === 3 && !node.nodeValue.trim()) { p.removeChild(node); node = next; continue; }
        if (node.nodeType === 1 && node.tagName === 'BR') { p.removeChild(node); }
        break;
      }
      var lead = document.createElement('p');
      while (p.firstChild) lead.appendChild(p.firstChild);
      if (lead.textContent.trim() || lead.children.length) body.appendChild(lead);

      g.extra.forEach(function (e) { body.appendChild(e); });
      d.appendChild(body);

      p.parentNode.insertBefore(d, p);
      p.parentNode.removeChild(p);
    });

    // open a row that was deep-linked to
    if (window.location.hash.length > 1) {
      var target = root.querySelector(window.location.hash.replace(/[^#\w-]/g, ''));
      if (target && target.tagName === 'DETAILS') {
        target.open = true;
        target.scrollIntoView({ block: 'center' });
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-faq-acc]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

/* ------------------------------------------------------------
   Product gallery v2: pause a video the moment you slide off it.
   The gallery JS above only toggles an "on" class, so watch for
   that and stop anything playing in a slide that just went dark.
   ------------------------------------------------------------ */
(function () {
  function stop(slide) {
    slide.querySelectorAll('video').forEach(function (v) {
      try { v.pause(); } catch (e) {}
    });
    slide.querySelectorAll('iframe').forEach(function (f) {
      // reloading the src is the only reliable way to stop an embed
      var src = f.getAttribute('src');
      if (src) { f.setAttribute('src', src); }
    });
  }

  function watch(gallery) {
    if (gallery.dataset.vwatch) return;
    gallery.dataset.vwatch = '1';
    var slides = gallery.querySelectorAll('.gslide');
    if (!slides.length) return;
    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        var el = m.target;
        if (el.classList && el.classList.contains('gslide') && !el.classList.contains('on')) stop(el);
      });
    });
    slides.forEach(function (s) {
      obs.observe(s, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-gallery]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
